export type UserFriendlyUnitEntry = {
  label: string;
  id: number;
  machineName: string;
};

export const User_Friendly_Units: Record<number, UserFriendlyUnitEntry> & {
  all: number[];
} = {
  0: { label: "Not Specified", id: 0, machineName: "Not Specified" },
  1: { label: "Cup", id: 1, machineName: "Cup" },
  2: { label: "Serving", id: 2, machineName: "Serving" },
  3: { label: "Package", id: 3, machineName: "Package" },
  4: { label: "Slice", id: 4, machineName: "Slice" },
  5: { label: "Table Spoon", id: 5, machineName: "TableSpoon" },
  6: { label: "Tea Spoon", id: 6, machineName: "TeaSpoon" },
  7: { label: "Item", id: 7, machineName: "Item" },
  8: { label: "Glass", id: 8, machineName: "Glass" },
  9: { label: "Ounce", id: 9, machineName: "Ounce" },
  10: { label: "Scoop", id: 10, machineName: "Scoop" },
  11: { label: "Milliliters", id: 11, machineName: "Milliliters" },
  12: { label: "One Handful", id: 12, machineName: "OneHandful" },
  13: { label: "Two Handfuls", id: 13, machineName: "TwoHandfuls" },
  14: { label: "Thumb", id: 14, machineName: "Thumb" },
  15: { label: "Palm", id: 15, machineName: "Palm" },
  16: { label: "Thumb Tip", id: 16, machineName: "ThumbTip" },
  17: { label: "Fist", id: 17, machineName: "Fist" },
  18: { label: "Grams", id: 18, machineName: "Grams" },
  all: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
};
